<template>
    <main-content with_go_back_bar>
        <register-pos-form v-if="constants && form_data" :form_data="form_data"
                           :wizard="wizard"></register-pos-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {manageDocuments} from '@/constants/PosStatus'
import RegisterPosForm from "./components/register-pos-form";
import {mapGetters} from "vuex";

export default {
    components: {
        RegisterPosForm,
        'main-content': mainContent,
    },
    data() {
        return {
            manageDocuments,
            wizard: {
                current_step: 1,
                show: true,
                navigable: true,
                submit_in_progress: false,
                newCustomer:false,
                operation:'create',
                document_operation: manageDocuments.EDIT,
            },
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            currentTab: 1,
            query: {},
        }
    },
    computed: {
        form_data: {
            get: function () {
                return this.$store.state.pos.form_data
            },
            set: function (value) {
                this.$store.commit('pos/setFormData', value)
            },
            clear: function () {
                this.$store.commit('pos/clearFormData')
            }
        },
        ...mapGetters('pos', [
            'constants','psp'
        ])
    },
    methods: {
        gotoTab(selectedTab) {
            this.currentTab = selectedTab;
            window.localStorage.setItem('tr_routing_active_tab', selectedTab);
        },
    },
    mounted() {
        this.$store.dispatch('pos/fetch')
        this.$store.commit('pos/clearFormData')
    }
}
</script>

<style>

</style>